export { RENDERER_TYPE, autocompleteRenderer } from "./autocompleteRenderer.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/renderers/autocompleteRenderer/index.mjs
// module id = 234
// module chunks = 1